import { render, staticRenderFns } from "./welcome-screen-form.vue?vue&type=template&id=7f3449ef"
import script from "./welcome-screen-form.component.js?vue&type=script&lang=js&external"
export * from "./welcome-screen-form.component.js?vue&type=script&lang=js&external"
import style0 from "./welcome-screen-form.vue?vue&type=style&index=0&id=7f3449ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCardActions,VForm,VSelect,VTextarea})
